"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DndProvider;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactDnd = require("react-dnd");
var _excluded = ["backend", "children"];
var DndProviderContext = /*#__PURE__*/_react.default.createContext([]);
function DndProvider(_ref) {
  var backend = _ref.backend,
    children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(DndProviderContext.Consumer, null, function (value) {
    if (value && value.includes(backend)) {
      return children;
    } else {
      var v2 = value.slice();
      v2.push(backend);
      var iframeElement = document.querySelector("iframe");
      return /*#__PURE__*/_react.default.createElement(DndProviderContext.Provider, {
        value: v2
      }, /*#__PURE__*/_react.default.createElement(_reactDnd.DndProvider, Object.assign({
        backend: backend
      }, props, {
        options: {
          rootElement: iframeElement ? iframeElement.contentDocument : undefined
        }
      }), children));
    }
  });
}